/* ========================================================================
 * .noConflict()
 * Enclosed everything within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    /// is onscreen function
    $.fn.isOnScreen = function () {

        var win = $(window);

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        };

        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = this.offset();
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

    };

    var scrollTimeout;
    var throttle = 50;

    function scroll_function(scroll) {
        if (!scrollTimeout) {
            scrollTimeout = setTimeout(function () {
                var st = $(this).scrollTop();

                checkDivs();

                scrollTimeout = null;
            }, throttle);
        }

        lazy();
    }

    scroll_function($(window).scrollTop());



    /// Scroll animations
    $(window).on('scroll', function () {
        var scroll = $(this).scrollTop();
        scroll_function(scroll);

        if(scroll > 50){
            $('header').addClass('scrollanim');
            $('header').addClass('scroll');
            $('.navbar').addClass('scroll');
        }else{
            $('header').removeClass('scroll');
            $('header').removeClass('scrollanim');
            $('.navbar').removeClass('scroll');
        }

        $('.scrollDiv.start').each(function () {
            if ($(this).isOnScreen()) {
            }
        });

        lazy();
    });

    function lazy() {
        $('img.lazy').each(function () {
            if ($(this).isOnScreen()) {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).removeClass('lazy');

                if ($(this).parent().hasClass('liquid')) {
                    $(this).parent().css('background-image', 'url(' + $(this).attr('data-src') + ')');
                }
            }
        });
    }
    lazy();

    var checkDivs = function () {
        $('.anim.start').each(function () {
            if ($(this).isOnScreen() === true) {
                var anim = $(this).attr('data-anim');
                var speed = $(this).attr('data-speed');
                var delay = $(this).attr('data-delay');

                if (speed === null) {
                    speed = 700;
                }

                if (anim === 'fadeUp') {
                    $(this).velocity({translateZ: 0, translateY: '-30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeDown') {
                    $(this).velocity({translateZ: 0, translateY: '30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeLeft') {
                    $(this).velocity({translateZ: 0, translateX: '-30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeRight') {
                    $(this).velocity({translateZ: 0, translateX: '30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeIn') {
                    $(this).velocity({opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({opacity: 1}, {duration: speed, delay: delay});
                }

            }
        });
    };

    $('.anim').each(function () {
        $(this).addClass('start').css('opacity', 0);
    });

    /// load foundation
    $(document).foundation();

    $('.hero-mh').matchHeight();
    $('.adresgegevens-mh').matchHeight();
    $('.team-mh').matchHeight();
    $('.blok-mh').matchHeight();
    $('.archive-mh').matchHeight();
    $('.blog-ac-titel-mh').matchHeight();
    $('.intro-mh').matchHeight();
    $('.inner-bericht-mh').matchHeight();
    $('.partner-img-mh').matchHeight();
    $('.single-vier-tekstblokken .inner').matchHeight();
    $('.bericht-column-mh').matchHeight();
    $('.dienst-inner-mh').matchHeight();
    $('.dienst-content-mh').matchHeight();
    $('.dienst-titel-mh').matchHeight();
    $('.afbeelding-mh').matchHeight();
    $('.partner-inner-mh').matchHeight();
    $('.sub-inner').matchHeight();
    $('.tekstblok-mh').matchHeight();

    $('.referentie-slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        autoplay: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.vaste-partners-slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    autoplay: true
                }
            },
            {
                breakpoint: 400,
                settings: {
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            }
        ]
    });

    $('.referentie-img-slider').slick({
        dots: false,
        arrows: false,
        drag: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
    });


    $('.referentie-video-slider').slick({
        dots: true,
        arrows: true,
        asNavFor: '.referentie-img-slider',
        prevArrow: '<span class="slick-prev"><img src="'+theme_directory+'/source/images/arrow.svg" alt=""></i></span>',
        nextArrow: '<span class="slick-next"><img src="'+theme_directory+'/source/images/arrow.svg" alt=""></span>',
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $('.partners-slider-variable').slick({
        dots: true,
        arrows: true,
        prevArrow: '<span class="slick-prev"><img src="'+theme_directory+'/source/images/arrow.svg" alt=""></i></span>',
        nextArrow: '<span class="slick-next"><img src="'+theme_directory+'/source/images/arrow.svg" alt=""></span>',
        infinite: true,
        autoplay: true,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
        ]
    });

    $('.foto-slider-slider').slick({
        dots: false,
        arrows: true,
        prevArrow: '<span class="slick-prev"><img src="'+theme_directory+'/source/images/arrow.svg" alt=""></i></span>',
        nextArrow: '<span class="slick-next"><img src="'+theme_directory+'/source/images/arrow.svg" alt=""></span>',
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1
    });

    $('.blog-archive-slider').slick({
        dots: false,
        arrows: true,
        prevArrow: '<span class="slick-prev"><img src="'+theme_directory+'/source/images/arrow-white.svg" alt=""></i></span>',
        nextArrow: '<span class="slick-next"><img src="'+theme_directory+'/source/images/arrow-white.svg" alt=""></span>',
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToScroll: 1
    });

    $('.berichten-slider').slick({
        dots: false,
        arrows: true,
        drag: false,
        prevArrow: '<span class="slick-prev"><img src="'+theme_directory+'/source/images/arrow.svg" alt=""></i></span>',
        nextArrow: '<span class="slick-next"><img src="'+theme_directory+'/source/images/arrow.svg" alt=""></span>',
        infinite: false,
        speed: 350,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: false,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        responsive: [
            {
                breakpoint: 650,
                settings: {
                    adaptiveHeight: true
                }
            }
        ]
    });

    $('.vacature-afbeelding-slider-slide').slick({
        dots: false,
        arrows: true,
        drag: false,
        prevArrow: '<span class="slick-prev"><img src="'+theme_directory+'/source/images/arrow.svg" alt=""></i></span>',
        nextArrow: '<span class="slick-next"><img src="'+theme_directory+'/source/images/arrow.svg" alt=""></span>',
        infinite: false,
        speed: 650,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true
                }
            }
        ]
    });

    $('.menu-btn').click(function(){
        $('.header-overlay').fadeIn();
        $('.side-menu').addClass('active');
    });


    // Smooth scroll to ID
    if(window.location.hash) {
        var hash = window.location.hash;

        $('html, body').animate({
            scrollTop: $(hash).offset().top - 110
        }, 600, 'swing');
    }

    $('.close-overlay, .white-overlay').click(function(){
        $('.header-overlay').fadeOut('slow');
        $('.side-menu').removeClass('active');
    });

   $('.play-button').click(function(){
      $('body').toggleClass('lock');

      $('#video').css('display', 'block');

      setTimeout(function(){
          $('#video').css('opacity', 1);
          $('#video')[0].play();
      },100);

      // $('.video-box').fadeIn(1300);
   });

    $('.play-button-overzicht').click(function(){
        $('body').toggleClass('lock');

        $(this).hide().find('video').hide();

        $(this).parent().closest('.head').find('video').css('display', 'block');;
        $(this).parent().closest('.head').find('video')[0].play();
        $(this).parent().closest('.head').find('video').css('opacity', 1);
        $(this).parent().closest('.head').find('.spread').fadeOut(3500);

        // $('.video-box').fadeIn(1300);
    });

   $('.video-box').click(function(){
       $('body').toggleClass('lock');

       $('.video-box').fadeOut(1300);
   });



    $('.pijl img').click(function(){
        $([document.documentElement, document.body]).animate({
            scrollTop: $($(this).closest('section').next()).offset().top + 40
        }, 700);
    });

    /// Scroll animations
    $(window).on('scroll', function () {
        var scroll = $(this).scrollTop();

        $('.scrollDiv.start').each(function () {
            if ($(this).isOnScreen()) {

            }
        });

        lazy();
    });

    function lazy() {
        $('img.lazy').each(function () {
            if ($(this).isOnScreen()) {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).removeClass('lazy');

                if ($(this).parent().hasClass('liquid')) {
                    $(this).parent().css('background-image', 'url(' + $(this).attr('data-src') + ')');
                }
            }
        });
    }
    lazy();

    $('.inner-bericht').click(function(){
       var id = $(this).attr('data-id');

        $('.inner-bericht.active').removeClass('active');
        $(this).addClass('active');

       $('.berichten .head').fadeOut();
       $('.berichten .head.data-class-' + id).fadeIn();

        $('.berichten-slider').slick('slickGoTo', id - 1);
    });

    $('.berichten .slick-next').click(function(){
       var slickid = $('.berichten .slick-current').attr('data-slick-index');
       slickid = parseInt(slickid) + 1; // Due to starting at 0

        $('.inner-bericht.active').removeClass('active');
        $($('.inner-bericht.data-class-' + slickid)).addClass('active');

        $('.berichten .head').fadeOut();
        $('.berichten .head.data-class-' + slickid).fadeIn();
    });

    $('.berichten .slick-prev').click(function(){
        var slickid = $('.berichten .slick-current').attr('data-slick-index');
        slickid = parseInt(slickid) + 1; // Due to starting at 0

        $('.inner-bericht.active').removeClass('active');
        $($('.inner-bericht.data-class-' + slickid)).addClass('active');

        $('.berichten .head').fadeOut();
        $('.berichten .head.data-class-' + slickid).fadeIn();
    });

    $('.liquid').imgLiquid();

    $(document).ready(function(){
        $('.white-loader-overlay').fadeOut();
    });

    var referentie_click = 0;

    $('.referentie-video-slider .slick-next').click(function(){
        if($(this).hasClass('slick-disabled')){
            referentie_click = referentie_click + 1;

            if(referentie_click > 1){
                window.location.href = referenties_pagina;
            }
        }
    });

    function checkSliders(){
        if (screen.width < 1040) {
            $('.overzicht-klanten-slider').slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 300,
                autoplay: true,
                autoplaySpeed: 2000,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 400,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }
                ]
            });
        }
    }

    $('#scan-form-btn').click(function(){

        $('.loader').fadeIn();

        var send = true;

       var url = $('.scan-form #url').val();
       var voornaam = $('.scan-form #voornaam').val();
       var achternaam = $('.scan-form #achternaam').val();
       var bedrijf = $('.scan-form #bedrijf').val();
       var email = $('.scan-form #email').val();

       if(voornaam.length < 3 || achternaam.length < 3){
           send = false;

           Swal.fire(
               'Oops',
               'Your name seems to be a little short..',
               'warning'
           )
       }

       var data = {
           url : url,
           voornaam : voornaam,
           achternaam : achternaam,
           bedrijf : bedrijf,
           email : email
       };

       if(send){
           var request = $.ajax({
               url:  theme_directory +  "/ajax/guardian360.php",
               method: "POST",
               data: {data: data},
               dataType: "html"
           });

           request.done(function (output) {
               $('.loader').fadeOut();

               if(output === 'Email has been sent successfully'){
                   if(lang == 'nl'){
                       Swal.fire(
                           'Gelukt!',
                           'Je krijgt de scan per e-mail binnen',
                           'success'
                       )
                   }else{
                       Swal.fire(
                           'Success!',
                           'You will recieve your scan per email',
                           'success'
                       )
                   }

               }else{
                   if(lang == 'nl'){
                       Swal.fire({
                           icon: 'error',
                           title: 'Oeps...',
                           text: 'We konden je aanvraag niet versturen',
                       })
                   }else{
                       Swal.fire({
                           icon: 'error',
                           title: 'Oops...',
                           text: 'We could not send your request',
                       })
                   }

               }
           });

           request.fail(function (jqXHR, textStatus) {
               $('.loader').fadeOut();

               if(lang == 'nl'){
                   Swal.fire({
                       icon: 'error',
                       title: 'Oeps...',
                       text: 'We konden je aanvraag niet versturen',
                   })
               }else{
                   Swal.fire({
                       icon: 'error',
                       title: 'Oops...',
                       text: 'We could not send your request',
                   })
               }
           });
       }

    });

    checkSliders();

    $( window ).resize(function() {
        checkSliders();
    });


})(jQuery); // Fully reference jQuery after this point.